<template>
    <div id="edit-item-modifier">
        <vs-popup title="Edit modifier" class="edit-item-modifier-popup" :active.sync="config.isActive">
            <div>
                <div class="edit-item-modifier-content">
                    <div class="info-form px-4">
                        <vs-input label="Modifier name" v-validate="'required'" name="name" v-model="name" placeholder="Input modifier name" class="w-full" :danger="errors.has('name')"
                            danger-text="The name field is required" v-on:input="checkExistName($event)" v-if="nameExist == false"/>
                        <vs-input label="Modifier name" v-validate="'required'" name="name" v-model="name" placeholder="Input modifier name" class="w-full" :danger="nameExist"
                            danger-text="This name is existed" v-on:input="checkExistName($event)" v-else/>

                        <vs-checkbox class="my-base mx-0 text-sm" v-model="typeModifier">Customer can only select one modifier</vs-checkbox>

                        <vs-checkbox class="my-base mx-0 text-sm" v-model="requiredModifier">Required Modifier</vs-checkbox>

                        <vs-row class="border-custom border-r-0 border-b-0">
                            <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Modifier</vs-col>
                            <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Price - $</vs-col>
                            <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Remove</vs-col>
                        </vs-row>
                        <div class="modifier-table">
                            <vs-row class="border-custom border-r-0 border-t-0" v-for="(modifier, index) in modifier_list" :key="index">
                                <vs-col vs-w="4" class="border-right-custom text-center p-2">
                                    <vs-input v-model="modifier.name" class="w-full h-full"/>
                                </vs-col>
                                <vs-col vs-w="4" class="border-right-custom text-center p-2">
                                    <vs-input v-model="modifier.price" class="w-full h-full" v-on:keypress="isPriceNumber($event, modifier.price)"/>
                                </vs-col>
                                <vs-col vs-w="4" class="border-right-custom text-center p-2 flex align-center justify-center">
                                    <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 stroke-current text-primary" @click="removeModifier(modifier)" v-if="modifier_list.length>1"/>
                                </vs-col>
                            </vs-row>
                            <div class="add-modifier-btn-container">
                                <div class="add-modifier-btn" @click="addModifier"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-divider></vs-divider>
                <div class="vx-row justify-center my-3" slot="footer">
                    <vs-button color="primary" class="text-white mr-3" @click="saveModifier">Save</vs-button>
                    <vs-button type="border" color="danger" class="text-danger ml-3" @click="closePopup">Cancel</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
    export default {
        name: 'edit-item-modifier',
        props: {
            config: {
                type: Object
            }
        },
        data() {
            let name = '';
            let modifier_list = [{index: 0, name: '', price: 0.00}];
            let requiredModifier = false;
            let typeModifier = false;
            if(this.config && this.config.type == 'edit' && this.config.item_info) {
                name = this.config.item_info.modifier_name;
                modifier_list = this.getModifierList(this.config.item_info.details);
                requiredModifier = this.config.item_info.required;
                typeModifier = this.config.item_info.type == 'multi' ? false : true;
            }
            return {
                name,
                modifier_list,
                requiredModifier,
                typeModifier,
                nameExist: false
            }
        },
        watch: {
            config: {
                immediate: true,
                deep: true,
                handler() {
                    this.errors.clear();
                    if(this.config && this.config.type == 'edit' && this.config.item_info) {
                        this.name = this.config.item_info.modifier_name;
                        this.modifier_list = this.getModifierList(this.config.item_info.details);
                        this.requiredModifier = this.config.item_info.required;
                        this.typeModifier = this.config.item_info.type == 'multi' ? false : true;
                    } else {
                        this.name = '';
                        this.modifier_list = [{index: 0, name: '', price: 0.00}];
                        this.requiredModifier = false;
                        this.typeModifier = false;
                    }
                }
            }
        },
        methods: {
            checkExistName(evt) {
                // console.log(evt)
                this.nameExist = false;
                if(this.config && this.config.modifierList) {
                    for(let i = 0; i < this.config.modifierList.length; i++) {
                        if(evt.trim() == this.config.modifierList[i].modifier_name.trim() && this.config.modifierList[i].index != this.config.item_info.index) {
                            this.nameExist = true;
                            return;
                        }
                    }
                }
            },
            getModifierList(list) {
                let arr = [];
                if(list) {
                    for(let i = 0; i < list.length; i++) {
                        arr.push({
                            index: i,
                            name: list[i].name,
                            price: parseFloat(list[i].price).toFixed(2)
                        });
                    }
                }
                if(arr.length == 0) {
                    arr = [{index: 0, name: '', price: 0.00}];
                }
                return arr;
            },
            isPriceNumber(evt, price) {
                evt = evt ? evt : window.event;
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (
                    (charCode > 31 &&
                    (charCode < 48 || charCode > 57) &&
                    charCode !== 46) ||
                    (charCode == 46 && price.indexOf(".") != -1)
                ) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            addModifier() {
                // console.log('dd')
                this.modifier_list.push({
                    index: this.modifier_list && this.modifier_list.length > 0 ? this.modifier_list[this.modifier_list.length - 1].index + 1 : 0,
                    name: '',
                    price: 0.00
                })
            },
            removeModifier(modifier) {
                for (let i = 0; i < this.modifier_list.length; i++) {
                    if (this.modifier_list[i].index == modifier.index) {
                        this.modifier_list.splice(i, 1);
                        return;
                    }
                }
            },
            closePopup() {
                this.$emit("ClosePopup");
            },
            getModifierListToSave(list) {
                let arr = [];
                for(let i = 0; i < list.length; i++) {
                    if(list[i].name != '') {
                        arr.push(list[i]);
                    }
                }
                for(let i = 0; i < arr.length; i++) {
                    delete arr[i].index;
                    if(arr[i].price == '') {
                        arr[i].price = 0;
                    }
                }
                return arr;
            },
            saveModifier() {
                if(this.name != '' && this.nameExist == false) {
                    let obj = {
                        // id: this.config.item_info.id ? this.config.item_info.id : null,
                        index: this.config.item_info.index,
                        name: this.name,
                        type: this.typeModifier == false ? "multi" : "single",
                        required: this.requiredModifier,
                        details: this.getModifierListToSave(this.modifier_list)
                    }
                    this.$emit('SaveModifier', obj);
                }
                this.$validator.validateAll();
            }
        }
    }
</script>